export const RECORDING_TYPE = {
    PERSONAL: "local",
    SERVER: "server"
}